import React from 'react'

export const GridPopover: React.FC = () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <title>Icon/Grid Popover</title>
    <g id="Icon/Grid-Popover" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group" transform="translate(4.000000, 4.000000)" stroke="#000000">
        <rect id="Rectangle" x="0.5" y="0.5" width="6" height="6"></rect>
        <rect id="Rectangle-Copy-2" x="0.5" y="9.5" width="6" height="6"></rect>
        <rect id="Rectangle-Copy" x="9.5" y="0.5" width="6" height="6"></rect>
        <rect id="Rectangle-Copy-3" x="9.5" y="9.5" width="6" height="6"></rect>
      </g>
    </g>
  </svg>
)
